import { ILinkProps } from "../components/ActionsSelectors/Link/Link";

export const listData: {
  title: string;
  links: ILinkProps[];
}[] = [
  {
    title: "Help",
    links: [
      { text: "Delivery", href: "#" },
      { text: "Returns", href: "#" },
      { text: "Payment options", href: "#" },
      { text: "Size guide", href: "#" },
      { text: "FAQ’s", href: "#" },
      { text: "Contact Us", href: "#" },
      { text: "Find a store", href: "#" },
    ],
  },
  {
    title: "About",
    links: [
      { text: "About us", href: "#" },
      { text: "Press", href: "#" },
      { text: "Join us", href: "#" },
      { text: "Our Stores", href: "#" },
      { text: "Blog", href: "#" },
    ],
  },
  {
    title: "Services",
    links: [
      { text: "Bike analysis & adjustment", href: "#" },
      { text: "Bikeservice", href: "#" },
      { text: "Bootfitting", href: "#" },
      { text: "E-bike insurance", href: "#" },
      { text: "Guarantee services", href: "#" },
      { text: "Gift card", href: "#" },
      { text: "Test & Buy", href: "#" },
    ],
  },
  {
    title: "Popular",
    links: [
      { text: "Running", href: "#" },
      { text: "Football", href: "#" },
      { text: "Fitness", href: "#" },
    ],
  },
];

export const checkoutFooterLinks: ILinkProps[] = [
  { text: "Delivery & Returns", href: "#" },
  { text: "Help & Contact", href: "#" },
  { text: "Payment options", href: "#" },
  { text: "FAQ’s", href: "#" },
];
